import i18next from 'i18next'

import { convertAreaLabel } from '~/models/area'
import {
  selfRoleLabel,
  supplyFormLabel,
} from '~/pages/AdminOcctoMaster/tabs/SplitSupplyContract/models/labels'
import type { SplitSupplyContractRow } from '~/pages/AdminOcctoMaster/tabs/SplitSupplyContract/types'
import type { CsvColumnDef } from '~/pages/AdminOcctoMaster/tabs/_common/models/csvExport'

const NS = 'page:adminOcctoMaster.splitSupplyContract.column' as const

const business = (b: { code: string; name: string }): string =>
  b.name === '' ? b.code : `${b.code} ${b.name}`

/**
 * 分割供給契約タブの CSV エクスポート列。 一覧の列と同じ (基本パターンは含めない)。
 * 区分値は表示言語のラベルで出す。
 */
export function splitSupplyContractCsvColumns(): Array<
  CsvColumnDef<SplitSupplyContractRow>
> {
  const t = i18next.t.bind(i18next)
  return [
    {
      headerKey: `${NS}.areaCode`,
      accessor: (row) =>
        row.areaCode === undefined ? '' : convertAreaLabel(row.areaCode),
    },
    {
      headerKey: `${NS}.supplyPointSpecificNumber`,
      accessor: (row) => row.supplyPointSpecificNumber,
    },
    {
      headerKey: `${NS}.customerName`,
      accessor: (row) => row.customerName ?? '',
    },
    {
      headerKey: `${NS}.supplyForm`,
      accessor: (row) => supplyFormLabel(t, row.supplyForm),
    },
    {
      headerKey: `${NS}.loadFollowing`,
      accessor: (row) => business(row.loadFollowing),
    },
    {
      headerKey: `${NS}.base`,
      accessor: (row) => business(row.base),
    },
    {
      headerKey: `${NS}.selfRole`,
      accessor: (row) => selfRoleLabel(t, row.selfRole),
    },
  ]
}
